import apiClient from '@/utils/apiClient'

export interface PlanPrice {
    planId: string
    price: number
    currency: string
    isCustomPrice: boolean
}

export interface PlanCard {
    code: string
    name: string
    description: string
    features: Record<string, any>
    sortOrder: number
    prices: {
        monthly?: PlanPrice
        yearly?: PlanPrice
    }
}

export interface ScheduledChange {
    kind: 'downgrade' | 'cancel'
    planId: string | null
    interval: 'monthly' | 'yearly' | null
    effectiveAt: string | null
}

export interface SubscriptionView {
    plan: {
        code: string
        name: string
        interval: 'monthly' | 'yearly' | null
        features: Record<string, any>
    }
    status: string
    price: number | null
    isCustomPrice: boolean
    isComped: boolean
    renewsAt: string | null
    usage: {
        responses: { used: number; limit: number | null }
    }
    limits: {
        monthlyResponses: number | null
        surveys: number | null
        questions: number | null
    }
    scheduledChange: ScheduledChange | null
}

export const getPlans = async (): Promise<PlanCard[]> => {
    const response = await apiClient.get('/billing/plans')
    return response.data.data.plans
}

export const getSubscription = async (): Promise<SubscriptionView> => {
    const response = await apiClient.get('/billing/subscription')
    return response.data.data
}

export const subscribe = async (params: {
    planCode: string
    interval: 'monthly' | 'yearly'
    returnUrl?: string
}): Promise<{ confirmationUrl: string; price: number; isCustomPrice: boolean }> => {
    const response = await apiClient.post('/billing/subscribe', params)
    return response.data.data
}

export const cancelSubscription = async (): Promise<{ effectiveAt: string }> => {
    const response = await apiClient.post('/billing/subscription/cancel')
    return response.data.data
}

export const revertScheduledChange = async (): Promise<{ reverted: string }> => {
    const response = await apiClient.post(
        '/billing/subscription/scheduled-change/revert'
    )
    return response.data.data
}
